var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ad-comp"},[_c('img',{staticClass:"img-responsive",attrs:{"src":_vm.adImg.path,"alt":""},on:{"click":function($event){return _vm.handleBlockClick(_vm.adv1.linkurl)}}})])}
var staticRenderFns = []

export { render, staticRenderFns }